export default defineAppConfig({
  formLayer: {},
});

declare module "@nuxt/schema" {
  interface AppConfigInput {
    formLayer?: {};
  }
}
